import React from 'react';
import {isPostEditor} from 'polyphony/util';
import {BrokenDocument} from 'polyphony/icons';

function register() {
    const { registerBlockType } = window.wp.blocks;

    registerBlockType('polyphony/page-fold', {
        title: "Polyphony Page Fold",
        icon: <BrokenDocument />,
        category: 'common',
        keywords: ['polyphony', 'page', 'fold'],
        supports: { html: false },
        attributes: {},
        edit: () => <div className='polyphony-page-fold-container'><hr className='polyphony-page-fold' /></div>,
        save: () => <div />
    });
}

if (isPostEditor()) {
    register();
}

